/**
 * Created by Languagenut on 04/02/2020.
 */


export default class LanguagenutPackage{

    constructor(data){
        this.data = data;
    }


    isPrimary(){

    }

    isDutch(){
        var secondaryPackages = [
            14,
            51,
            52,
            53,
            59,
            69
        ]

        if(secondaryPackages.indexOf(Number(sessionStorage.packageUid)) >= 0)
        {
            return true;
        }

        return false;
    }

    isSecondary($packageUid){
        var secondaryPackages = [
            33,
            34,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            60,
            61,
            62,
            63,
            66,
            67,
            70,
            71,
            72,
            73,
            74,
            79,
            80,
            82
        ]
        if ($packageUid == undefined && secondaryPackages.indexOf(Number(sessionStorage.packageUid)) >= 0) {
            return true;
        } else if(secondaryPackages.indexOf(Number($packageUid)) >= 0) {
            return true
        }

        return false;
    }

    isNewcomer($packageUid){
        var secondaryPackages = [
            54,55,56,57,58,59,64,69,72,77,78
        ]
        if ($packageUid == undefined && secondaryPackages.indexOf(Number(sessionStorage.packageUid)) >= 0) {
            return true;
        } else if(secondaryPackages.indexOf(Number($packageUid)) >= 0) {
            return true
        }

        return false;
    }


}